<template>
  <index
    :tabelDinamisBeranda="tabelDinamisBeranda"
    :tabelDinamisProjectCode="tabelDinamisProjectCode"
    :projectName="projectName"
  />
</template>

<!-- javascript section-->
<script>
//import js modules section
import Index from "./core_v3/Index.vue";

//local registration for output component
export default {
  props: {
    projectName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      tabelDinamisBeranda: this.projectName,
      tabelDinamisProjectCode: "Umum",
    };
  },
  created() {},
  destroyed() {},
  mounted: function () {},
  computed: {},
  watch: {},
  methods: {},
  components: {
    index: Index,
  },
};
</script>

<!-- css section-->
<style></style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 18-04-2021 -->
